import { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
import {
  getFirstLinkedItemOrDefault,
  getTrueFalseSingleChoiceValue,
} from '@r-and-a-shared-ui/common-kontent-client/utils';
import { getFirstMappedLinkedItemOrDefault } from './utils/component-mapping-helpers';
import mapLogo from './map-logo';

export const player_portals_header = (entry: PLAYER_PORTALS_MODELS.Header) => {
  if (!entry || !entry?.elements) {
    return undefined;
  }
  const { elements, system } = entry;

  const mobileRawLogo = getFirstLinkedItemOrDefault(elements?.mobile_logo);
  const desktopRawLogo = getFirstLinkedItemOrDefault(elements?.desktop_logo);

  const navLinked = elements?.navigation?.linkedItems ?? [];

  const firstMenu = navLinked.find(
    (i: any) => i?.system?.type === 'player_portals_menu',
  ) as PLAYER_PORTALS_MODELS.Menu | undefined;

  return {
    title: getFirstMappedLinkedItemOrDefault(elements?.title),
    mobileLogo: mapLogo(mobileRawLogo as PLAYER_PORTALS_MODELS.Logo),
    desktopLogo: mapLogo(desktopRawLogo as PLAYER_PORTALS_MODELS.Logo),
    hideChampionshipDropdown: getTrueFalseSingleChoiceValue(
      elements?.hide_championship_dropdown,
    ),
    hideMyAccount: getTrueFalseSingleChoiceValue(elements?.hide_my_account),
    navigation: firstMenu,
    kontentItemId: system?.id,
  };
};

export default player_portals_header;
